module.exports = __webpack_public_path__ + "static/media/s6.bdf04f82.jpg";